import React from "react";
import { useSelector } from "react-redux";


export default function IncomingCallModal({ data, onAccept, onReject }) {
 const { selectedAppt } = useSelector((state) => state.appt);

 console.log(selectedAppt,data);

 if (!data || data.length === 0) return null;

  return (
    <div className="incoming-call-container">
      {
        data && data?.filter((item) => selectedAppt? item.incomingCall.roomId !== selectedAppt.appointmentId: true)?.map((item) => (
          <div className="incoming-call-modal flex flex-col justify-between ">
            <div>
              <p><span className="font-semibold">{item?.incomingCall?.callerName}</span> is waiting for you. Please join the call.</p>
            </div>
            <div className="incoming-call-actions">
              <button className="reject-btn" onClick={() => onReject(item?.incomingCall?.roomId)}>Cancel</button>
              <button className="accept-btn" onClick={() => onAccept(item?.incomingCall?.roomId)}>Join</button>
            </div>
          </div>
        ))
      }

    </div>
  );
}
